import { CALL_API, Schemas } from '../../common/middleware/api';

export const CHILD_LESSONS_REQUEST = 'CHILD_LESSONS_REQUEST';
export const CHILD_LESSONS_SUCCESS = 'CHILD_LESSONS_SUCCESS';
export const CHILD_LESSONS_FAILURE = 'CHILD_LESSONS_FAILURE';

export const CHILD_LESSONS_DASHBOARD_REQUEST = 'CHILD_LESSONS_DASHBOARD_REQUEST';
export const CHILD_LESSONS_DASHBOARD_SUCCESS = 'CHILD_LESSONS_DASHBOARD_SUCCESS';
export const CHILD_LESSONS_DASHBOARD_FAILURE = 'CHILD_LESSONS_DASHBOARD_FAILURE';

export const MEDICAL_INFORMATION_FETCH_REQUEST = 'MEDICAL_INFORMATION_FETCH_REQUEST';
export const MEDICAL_INFORMATION_FETCH_SUCCESS = 'MEDICAL_INFORMATION_FETCH_SUCCESS';
export const MEDICAL_INFORMATION_FETCH_FAILURE = 'MEDICAL_INFORMATION_FETCH_FAILURE';

export const MEDICAL_INFORMATION_UPDATE_REQUEST = 'MEDICAL_INFORMATION_UPDATE_REQUEST';
export const MEDICAL_INFORMATION_UPDATE_SUCCESS = 'MEDICAL_INFORMATION_UPDATE_SUCCESS';
export const MEDICAL_INFORMATION_UPDATE_FAILURE = 'MEDICAL_INFORMATION_UPDATE_FAILURE';

export const MAKEUP_SUMMARY_BY_CHILD_AND_TERM_REQUEST = 'MAKEUP_SUMMARY_BY_CHILD_AND_TERM_REQUEST';
export const MAKEUP_SUMMARY_BY_CHILD_AND_TERM_SUCCESS = 'MAKEUP_SUMMARY_BY_CHILD_AND_TERM_SUCCESS';
export const MAKEUP_SUMMARY_BY_CHILD_AND_TERM_FAILURE = 'MAKEUP_SUMMARY_BY_CHILD_AND_TERM_FAILURE';

export const loadChildLessons = ({ childId, programId, forceReload }) => (dispatch, getState) => {
	const childLessonsByChildAndProgram = getState().filters.childLessonsByChildAndProgram;
	if (!forceReload && childLessonsByChildAndProgram[`${childId}-${programId}`]) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [CHILD_LESSONS_REQUEST, CHILD_LESSONS_SUCCESS, CHILD_LESSONS_FAILURE],
			endpoint: 'api/childLessons',
			request: { childId, programId },
			schema: Schemas.CHILD_LESSON_ARRAY
		},
		childId,
		programId
	});
};

export const loadChildLessonsForDashboard = (forceReload) => (dispatch, getState) => {
	const childLessonsForDashboard = getState().filters.childLessonsForDashboard;
	if (!forceReload && childLessonsForDashboard.all) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [CHILD_LESSONS_DASHBOARD_REQUEST, CHILD_LESSONS_DASHBOARD_SUCCESS, CHILD_LESSONS_DASHBOARD_FAILURE],
			endpoint: 'api/childLessons/dashboard',
			schema: Schemas.CHILD_LESSON_ARRAY
		}
	});
};

export const fetchMedicalInformation = (childId) => (dispatch, getState) => {
	if (getState().entities.medicalInformations[`${childId}`]) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [MEDICAL_INFORMATION_FETCH_REQUEST, MEDICAL_INFORMATION_FETCH_SUCCESS, MEDICAL_INFORMATION_FETCH_FAILURE],
			endpoint: `api/childMedicalInformations/${childId}`,
			schema: Schemas.MEDICAL_INFORMATION
		}
	});
}

export const updateMedicalInformation = (childId, medicalInfoFormResponse, history) => ({
	[CALL_API]: {
		types: [MEDICAL_INFORMATION_UPDATE_REQUEST, MEDICAL_INFORMATION_UPDATE_SUCCESS, MEDICAL_INFORMATION_UPDATE_FAILURE],
		endpoint: `api/childMedicalInformations/${childId}`,
		method: 'PUT',
		request: medicalInfoFormResponse,
		schema: Schemas.MEDICAL_INFORMATION,
		form: 'customForm',
		transition: history && {
			history,
			success: {
				push: true,
				path: '/children'
			}
		}
	}
});

export const loadMakeupSummaryByChildAndTerm = (childId, termId, forceReload) => (dispatch, getState) => {
	if (!forceReload && getState().filters.makeupSummaryByChildAndTerm[`${childId}-${termId}`]) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [MAKEUP_SUMMARY_BY_CHILD_AND_TERM_REQUEST, MAKEUP_SUMMARY_BY_CHILD_AND_TERM_SUCCESS, MAKEUP_SUMMARY_BY_CHILD_AND_TERM_FAILURE],
			endpoint: 'api/childLessons/makeupSummary',
			request: { childId, termId },
			schema: Schemas.MAKEUP_SUMMARY_ARRAY
		},
		childId,
		termId
	});
};
